import { useApiRead } from "source/shared/SessionApiResource"
import { useParams, useSearchParams } from "react-router-dom"
import { Helmet } from "react-helmet-async"
import { Error404, Icon } from "source/shared/components"
import { useQRCode } from "source/shared/QRCode"
import OpenGraphTags from "source/shared/OpenGraphTags"
import { Heading } from "@planningcenter/doxy-web"
import Form from "./Form"

export default function FormWrapper() {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const url = buildFormUrl(id, searchParams)
  useQRCode()

  const form = useApiRead(url)
  if (form.errors) return <Error404 />
  const pageTitle = form.data.attributes.name

  const { name, description } = form.data.attributes

  return (
    <>
      <OpenGraphTags
        title={pageTitle}
        description={form.data.attributes.og_form_description}
      />
      {form.data.attributes.accepting_submissions ? (
        <Form name={name} description={description} />
      ) : (
        <NotAcceptingSubmissions />
      )}
      <Helmet title={pageTitle} />
    </>
  )
}

const buildFormUrl = (id, searchParams) => {
  const email = searchParams.get("email")
  const _e = searchParams.get("_e")
  const query = new URLSearchParams()

  if (email) query.set("email", email)
  if (_e) query.set("_e", _e)

  return `/people/v2/forms/${id}${query.toString() ? `?${query}` : ""}`
}

function NotAcceptingSubmissions() {
  return (
    <div className="d-f ai-c fd-c">
      <Icon
        className="mb-2"
        style={{ fontSize: 32 }}
        symbol="general#x-circle"
      />
      <Heading level={2} text="This form is not accepting submissions" />
    </div>
  )
}
